// Shared constant variables
export const SPECIALTY_OPTIONS_BASE = [
	"General",
	"Vascular",
	"Orthopaedic",
	"Neurosurgery",
	"ENT",
	"Urology",
	"Plastics",
	"Cardiothoracic",
	"Colorectal",
	"Gynaecology",
	"Maxillofacial",
	"Paediatric",
	"Hepatobiliary",
	"Upper GI",
	"Breast",
	"Endocrine",
	"Spine",
	"Hand",
	"Foot & Ankle",
];

export const UNCATEGORISED = "Uncategorised";
